import Vue from "vue";
import store from "@/store";
import translate from "../languages/index";
let lang = store.state.language || "en";
export default {
  install() {
    Vue.prototype.$bet = {
      //
      // Get Bet Agente (return only bet data)
      //
      getBetAgent: async (id_bet, printed) => {
        // reset betcard
        store.commit("setBetCard", "");
        // setup api
        const endpoint = "agent/bets/getBetAgent";
        const params = {
          id_bet: Number(id_bet),
          printed: printed === 0 ? 0 : 1,
        };
        try {
          const response = await requestApi(endpoint, params);
          const betData = response.data.dados[0];
          store.commit("setBetCard", betData);
          store.commit("setBetAgent", response.data.agent);

          return {
            status: response.status,
            betData,
          };
        } catch (error) {
          const err = error;
          throw err;
        }
      },

      //
      // Get Bet Agente + Dialog:
      // Open dialog with betcard and return betdata
      //
      getBetAgentDialog: async (id_bet, printed) => {
        await Vue.prototype.$bet.getBetAgent(id_bet, printed);
        store.commit("setBetAgentDialog", true);
      },

      // Share Bet Ticket
      shareBetTicket: async (id_bet) => {
        let url = store.state.operators.url;

        // handler urls com barra no final
        if (url.charAt(url.length - 1) == "/") {
          url = url.slice(0, -1);
        }

        // mount url
        const betUrl = `${url}/bet/${id_bet}`;

        // https://whatwebcando.today/sharing.html
        // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/canShare
        var text = translate[lang].placeYourBet;
        if (!navigator.canShare) {
          const whatsAppUrl = `https://api.whatsapp.com/send?text=${text}:%20${betUrl}`;
          window.open(whatsAppUrl, "_newtab");
          return;
        }

        let shareData = {
          title: translate[lang].bettingTicket,
          text: text,
          url: betUrl,
        };

        try {
          await navigator.share(shareData);
        } catch (err) {
          console.log("Error sharing:", err);
        }
      },
    };
  },
};

// Constructor Request Api
const requestApi = (endpoint, params) => {
  store.commit("setFeedbackProgress", true);
  return new Promise((resolve, reject) => {
    Vue.prototype.$axios
      .post(`${endpoint}`, Vue.prototype.$formdata(params))
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
